var _rect, _rect2, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 24,
    rx: 8,
    fill: "#C03C3C",
    fillOpacity: 0.22
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 24,
    height: 23,
    rx: 7.5,
    stroke: "#C03C3C",
    strokeOpacity: 0.44
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.48101 9.28023C6.8708 8.46661 7.45134 7.30554 8.46836 7.30554H16.5316C17.5487 7.30554 18.1292 8.46661 17.519 9.28023V9.28023C17.0739 9.87365 16.8333 10.5954 16.8333 11.3372V14.8611C16.8333 17.0702 15.0425 18.8611 12.8333 18.8611H12.1667C9.95753 18.8611 8.16667 17.0702 8.16667 14.8611V11.3372C8.16667 10.5954 7.92608 9.87365 7.48101 9.28023V9.28023Z",
    stroke: "#C03C3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9443 15.2501L13.9443 10.9167",
    stroke: "#C03C3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0557 15.2501L11.0557 10.9167",
    stroke: "#C03C3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3891 7.30558L15.1227 6.50646C14.8505 5.68978 14.0862 5.13892 13.2254 5.13892H11.7751C10.9142 5.13892 10.1499 5.68978 9.8777 6.50646L9.61133 7.30558",
    stroke: "#C03C3C",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.346b37fceb1ce7977aaeac67b25dad04.svg";
export { ForwardRef as ReactComponent };